import { SMS_PROVIDER } from '../utils/smsDeeplink.js';

/**
 * Resolve the configured provider for SMS/text deeplinks.
 *
 * @returns {'system'|'zoom'} The provider identifier for deeplink generation.
 */
export function getSmsProvider() {
  const configured =
    typeof window !== 'undefined' && window?.APP_CONFIG?.smsProvider
      ? String(window.APP_CONFIG.smsProvider).toLowerCase()
      : 'default';

  if (configured === SMS_PROVIDER.ZOOM) {
    return SMS_PROVIDER.ZOOM;
  }

  return SMS_PROVIDER.SYSTEM;
}
